import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../Axios/axios';

// ara sayfa: token/rol/bayraklara bakar ve hedef sayfaya yönlendirir
export default function Landing() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  const toBool = (v) => {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v !== 0;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === 'true' || s === '1' || s === 'yes';
    }
    return false;
  };

  const getRole = (payload) =>
    payload?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ??
    payload?.role ??
    payload?.Role ??
    '';

  useEffect(() => {
    const decide = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login', { replace: true });
          return;
        }

        let payload = null;
        try {
          payload = JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
          console.error('JWT parse error', e);
          navigate('/login', { replace: true });
          return;
        }

        const role = String(getRole(payload) || '').trim().toLowerCase();

        // COMPANY dışı roller hızlı yönlendirme
        if (role === 'owner' || role === 'employee') {
          navigate('/grouptracking', { replace: true });
          return;
        }
        if (role === 'partner') {
          navigate('/partner', { replace: true });
          return;
        }
        if (role !== 'company') {
          navigate('/login', { replace: true });
          return;
        }

        // COMPANY ise bayraklar
        const companyId =
          payload?.CompanyId ?? payload?.companyId ?? payload?.companyID ?? null;

        // token'dan dene
        let hasTowerCrane =
          payload?.hasTowerCrane ?? payload?.HasTowerCrane ?? payload?.has_tower_crane;
        let rentTowerCrane =
          payload?.rentTowerCrane ?? payload?.RentTowerCrane ?? payload?.rent_tower_crane;

        hasTowerCrane = toBool(hasTowerCrane);
        rentTowerCrane = toBool(rentTowerCrane);

        // token'da yoksa API'den oku
        if (
          (typeof payload?.hasTowerCrane === 'undefined' &&
            typeof payload?.rentTowerCrane === 'undefined') ||
          (!hasTowerCrane && !rentTowerCrane)
        ) {
          if (companyId) {
            try {
              const res = await api.get(`/Company/GetById?id=${companyId}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              const c = res?.data?.data;
              if (c) {
                hasTowerCrane = toBool(c.hasTowerCrane ?? c.HasTowerCrane);
                rentTowerCrane = toBool(c.rentTowerCrane ?? c.RentTowerCrane);
              }
            } catch (e) {
              console.warn('Company/GetById failed', e);
            }
          }
        }

        // Öncelik sırası:
        // 1) hasTowerCrane -> /grouptracking
        // 2) rentTowerCrane -> /myrentals
        // 3) fallback -> /profile
        if (hasTowerCrane) {
          navigate('/grouptracking', { replace: true });
          return;
        }
        if (rentTowerCrane) {
          navigate('/myrentals', { replace: true });
          return;
        }
        navigate('/profile', { replace: true });
      } finally {
        setReady(true);
      }
    };

    decide();
  }, [navigate]);

  // minik bir boş/loader ekranı
  return ready ? null : (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', fontFamily: 'sans-serif', color: '#444'
    }}>
      Yönlendiriliyor...
    </div>
  );
}
